import React from 'react';
import PropTypes from "prop-types";
import {documentToReactComponents} from "@contentful/rich-text-react-renderer";
import TermsSection from "../TermsSection/TermsSection";
import {get} from "lodash";
import renderOptions from "../../../utils/richTextRendererOptions";
import idCreator from "../../../utils/idCreator";
import styles from '../Terms.module.scss';

const TermsTemplate = ({termsSections = [], paragraph, header = '', updatedDate = ''}) => {
    const renderSections = () => {
        const sections = (termsSections || []).map((section, index) => {
            const fields = get(section, 'fields', {});
            return <TermsSection key={index} {...fields} />
        })
        return <>{sections}</>
    }

    return (
        <div className={styles.template}>
            <h1 id={idCreator(header)}>{header}</h1>
            <p>{updatedDate}</p>
            {paragraph && <div>{documentToReactComponents(paragraph, renderOptions)}</div>}
            {renderSections()}
        </div>
    );
};

TermsTemplate.propTypes = {
    header: PropTypes.string,
    updatedDate: PropTypes.string,
    paragraph: PropTypes.object,
    termsSections: PropTypes.array
}

export default TermsTemplate;
